module.exports = __webpack_public_path__ + "img/zain-poster.a02521df.png";